/**
 * Carries the home page's active location/language filter onto the links that
 * leave it, so a visitor who narrowed the list keeps that narrowing when they
 * open an experience.
 *
 * The two pages filter over the same values but spell the params differently:
 * home uses repeated `locations`/`languages`, the experience page reads
 * repeated `locationId`/`language` (`routes/experience/route.tsx`). Both sides
 * take their ids and codes straight off the same event RPCs, so bridging them
 * is a rename, not a translation.
 *
 * Without it the experience page falls back to its own default location — the
 * first one, never "all" — so the visitor is shown a *different* location's
 * dates than the one they filtered for, with nothing saying so (US-11362).
 */
export type ExperienceLinkFilters = {
  locationIds: string[];
  languages: string[];
};

export function experienceFilterSearch(filters: ExperienceLinkFilters): string {
  const params = new URLSearchParams();
  for (const id of filters.locationIds) params.append('locationId', id);
  for (const code of filters.languages) params.append('language', code);
  return params.toString();
}

export function withExperienceFilters(path: string, search: string): string {
  return search ? `${path}?${search}` : path;
}
